import { WSContainer } from "@wingspanhq/fe-component-library";
import { WingspanProducts } from "@wingspanhq/users/dist/lib/interfaces";
import * as React from "react";
import { useHistory } from "react-router-dom";
import { BrowserPageTitle } from "../../components/BrowserPageTitle/BrowserPageTitle";
import { useUserId } from "../../query/hooks/helpers";
import {
  useUpdateActivity,
  useUpdateMemberProfile
} from "../../query/users/mutations";
import { useActivities, useMemberProfile } from "../../query/users/queries";
import { OnboardingHeader } from "../components/OnboardingHeader/OnboardingHeader";
import { OnboardingQuestion } from "../components/OnboardingQuestion/OnboardingQuestion";

interface OnboardingStep2Props {}

export const OnboardingStep2: React.FC<OnboardingStep2Props> = () => {
  const history = useHistory();
  const userId = useUserId();
  const [updateActivity, updateActivityMeta] = useUpdateActivity(userId);
  const qMember = useMemberProfile(userId);
  const qActivity = useActivities(userId);

  const [
    updateMemberProfile,
    updateMemberProfileMeta
  ] = useUpdateMemberProfile();
  const onBack = () => {
    history.push("/member/onboarding/step/1");
  };

  const onSubmit = async (data: any) => {
    if (qActivity.data?.events.benefitsOnlySignup) {
      data.productImportance = WingspanProducts.Benefits;
    }

    await updateMemberProfile({
      memberId: qMember.data?.memberId as string,
      profile: {
        productImportance: [data.productImportance]
      }
    });
    await updateActivity({
      flows: {
        onboarding: {
          version: 3,
          currentStep: 3,
          totalSteps: 4,
          complete: false
        }
      }
    });

    if (data.productImportance === WingspanProducts.Payments) {
      history.push("/member/onboarding/step/3/payments");
    } else if (data.productImportance === WingspanProducts.Bookkeeping) {
      history.push("/member/onboarding/step/3/bookkeeping");
    } else if (data.productImportance === WingspanProducts.Benefits) {
      history.push("/member/onboarding/step/3/benefits");
    }
  };
  return (
    <>
      <BrowserPageTitle title="Onboarding: Step 2" />
      <OnboardingHeader onBack={onBack} />
      <WSContainer verticalPadding>
        <OnboardingQuestion
          name="productImportance"
          question={{
            question: "You're our people!\nWhich is most top of mind?",
            options: [
              {
                label: "Making money",
                value: WingspanProducts.Payments,
                virtualAssistantMsg:
                  "Our platform enables you to send professional invoices, manage numerous clients, and automate complex pay schedules.",
                ctaBtnText: "Make more money"
              },
              {
                label: "Managing money",
                value: WingspanProducts.Bookkeeping,
                virtualAssistantMsg:
                  "Wingspan automatically handles bookkeeping, expenses, and even finds tax deductions for you.",
                ctaBtnText: "Save more money"
              },
              {
                label: "Big company benefits & perks",
                value: WingspanProducts.Benefits,
                virtualAssistantMsg:
                  "Wingspan can help you get the coverage you need and the perks you want with custom insurance and benefits packages for you and your family.",
                ctaBtnText: "Get covered"
              }
            ]
          }}
          onSubmit={onSubmit}
          isSubmitting={
            updateMemberProfileMeta.isLoading || updateActivityMeta.isLoading
          }
          defaultValues={{
            productImportance: qMember.data?.profile.productImportance?.[0]
          }}
        />
      </WSContainer>
    </>
  );
};
